module.exports = __webpack_public_path__ + "img/saj.9cabd354.png";